import AgoraRTC from 'agora-rtc-sdk-ng';

export default {
  createClient() {
    AgoraRTC.setArea({
      areaCode: 'GLOBAL'
    })

    return AgoraRTC.createClient({
      mode: 'rtc',
      codec: 'vp8'
    });
  }
}
